// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapperResetPassword {\n  width: 300px;\n  text-align: center;\n  margin-bottom: 130px;\n}\n@media screen and (max-width: 600px) {\n  .wrapperResetPassword {\n    margin-top: 60px;\n  }\n}\n.wrapperResetPassword .item {\n  margin-top: 70px;\n}\n.wrapperResetPassword .btn {\n  margin-top: 130px;\n}\n@media screen and (max-width: 600px) {\n  .wrapperResetPassword .btn {\n    margin-top: 30px;\n  }\n}", ""]);
// Exports
module.exports = exports;
